import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.75 10C16.75 9.58579 16.4142 9.25 16 9.25L4 9.25C3.58579 9.25 3.25 9.58579 3.25 10C3.25 10.4142 3.58579 10.75 4 10.75L16 10.75C16.4142 10.75 16.75 10.4142 16.75 10Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.53033 14.5303C8.82322 14.2374 8.82322 13.7626 8.53033 13.4697L5.06066 10L8.53033 6.53033C8.82322 6.23744 8.82322 5.76256 8.53033 5.46967C8.23744 5.17678 7.76256 5.17678 7.46967 5.46967L3.47012 9.46922C3.32947 9.60987 3.25 9.80109 3.25 10C3.25 10.1989 3.32902 10.3897 3.46967 10.5303L7.46967 14.5303C7.76256 14.8232 8.23744 14.8232 8.53033 14.5303Z",
  fill: "black"
}));
export { IconArrowLeft };